import { render, staticRenderFns } from "./TableDesign.vue?vue&type=template&id=16c6e392&"
import script from "./TableDesign.vue?vue&type=script&lang=js&"
export * from "./TableDesign.vue?vue&type=script&lang=js&"
import style0 from "./TableDesign.vue?vue&type=style&index=0&id=16c6e392&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TableDesign.vue"
export default component.exports